import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-mattablepaginator',
	templateUrl:'./MatTablePaginatorPage.html',
	styles: [],
	styleUrls:['./MatTablePaginatorPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatTablePaginatorPage
{
	mdContent_269 = `\`\`\`java
import com.jwebmp.plugins.angular.material.table.MatTablePaginator;
\`\`\``;
	mdContent_270 = `\`\`\`java
MatTablePaginator()
\`\`\``;
	mdContent_271 = `\`\`\`java
MatTablePaginator&lt;?&gt; paginator = new MatTablePaginator&lt;&gt;();
paginator.setPageSize(25);
paginator.setPageSizeOptions(List.of(10, 25, 50, 100));
paginator.setShowFirstLastButtons(true);
\`\`\``;
}
